import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getSearchSkillsApi } from '../../API/API'

function* getSearchSkillsSaga(params) {
  try {
    const response = yield call(() => getSearchSkillsApi(params));
    yield put({ type: types.GET_SEARCH_SKILLS_SUCCESS, payload: response.data });

  } catch (error) {
    yield put({ type: types.GET_SEARCH_SKILLS_FAILURE, error });
  }
}

export function* watchGetSearchSkillsSaga() {
  yield takeEvery(types.GET_SEARCH_SKILLS_REQUESTED, getSearchSkillsSaga);
}
